module.exports = __webpack_public_path__ + "static/media/g-1-a.bec01f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-1-a.jpg
// module id = 1124
// module chunks = 33